import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import { Prop, Watch } from "vue-property-decorator";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "ShippingAddressList" })
export default class ShippingAddressList extends Vue {
    public localizer: any = Localizer;
    public shippingAddress: any = null;
    public isEditAddress: boolean = false;
    public isLoading: boolean = false;
    public shippingAddresses: any[] = [];
    public countries: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly shippingMode: string;
    @Prop() readonly provinces: any;

    @Watch("isEditAddress") onIsEditAddress(newValue: boolean) {
        if (newValue) {
            document.body.classList.add("overflow");
        } else {
            document.body.classList.remove("overflow");
        }
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBeghelliShippingAddress_GetShippingAddresses)).data;
        this.shippingAddresses = result.addresses;
        this.countries = result.countries;
    }

    public async controlEdit(value: any) {
        this.$emit("isEditAddress", value);
        this.isEditAddress = value;

        await this.getData();
    }

    public newAddress(address: any) {
        this.shippingAddress = address;
        this.isEditAddress = true;
        this.$emit("isEditAddress", true);
    }

    public removeAddressDialog(address: any) {
        if (confirm(this.localizer.get("Store.Common.Shipping_Delete_Address"))) {
            this.removeAddress(address);
        }
    }

    public async removeAddress(address: any) {
        FormHelper.removeFocus();
        this.isLoading = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.MyBeghelliShippingAddress_DeleteShippingAddress, address);

            await this.getData();
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public async setDefaultAddress(address: any) {
        FormHelper.removeFocus();
        this.isLoading = true;
        this.validationErrors = [];

        try {
            await Axios.post(this.routes.MyBeghelliShippingAddress_SetDefaultShippingAddress, address);

            await this.getData();
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};